document.addEventListener('DOMContentLoaded', () => {
  const initEngine = () => {
    // Watch for new elements appearing (like related products loading via AJAX)
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                // Attach Swipers/Cart-buttons to any new product cards
                attachListenersToGrids();
            }
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const attachListenersToGrids = () => {
    document.querySelectorAll('.gangs-luxury-card-wrapper').forEach(card => {
       // Logic to initialize buttons/swipers here...
    });
  };

  initEngine();
});